export default __webpack_public_path__ + "static/media/ran.2b5e3cbc.png";